import { render, staticRenderFns } from "./profit_return_list.vue?vue&type=template&id=bacb5b3c"
import script from "./profit_return_list.vue?vue&type=script&lang=js"
export * from "./profit_return_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports